import React from 'react';
import ManagerDashboard from '.';
import { param, route } from '../../../utils/router';
import RedirectToHome from '../components/RedirectToHome';
import Expenses from './Expenses';
import EmployeePage from './EmployeePage';
import { ManagerRole } from '../__generated__/graphql';
import { EmployeeDocuments } from './EmployeePage/EmployeeDocuments/EmployeeDocuments';
import { managerRolesWhoHasAccessToDocuments } from '../pages/Documents2/constants';
import { AbsenceRequestsTabs } from './Absences/tabs';
import { EmployeeInventory } from './EmployeePage/EmployeeInventory/EmployeeInventory';
import { SupportPage } from '../pages/Support/SupportPage';
import { UserInfo } from '../context/UserInfo/types';
import { AnalyticsOverview } from '../pages/Analytics';
import { AbsenceRatePage } from '../pages/Analytics/AbsenceRate';
import { EmployeeTurnoverRatePage } from '../pages/Analytics/EmployeeTurnoverRate';
import { EmployeeOvertimePage } from '../pages/Analytics/EmployeeOvertime';
import { MyTeamTabs } from './MyTeam/tabs';

export const renderIfActive =
  (node: React.ReactNode) =>
  ({ isManagerModeAvailable, isActive }: UserInfo) =>
    isManagerModeAvailable && isActive ? node : <RedirectToHome />;

export const managerRoutes = {
  employeePage: {
    route: route('manager', 'employees', param('employeeId')),
    rolesWithAccess: [
      ManagerRole.DirectManager,
      ManagerRole.FeedbackManager,
      ManagerRole.AbsenceApprover,
      ManagerRole.TimeEntryApprover,
      ManagerRole.Compensation,
      ManagerRole.SeeEmployeeData,
      ManagerRole.HrManager,
    ],
    render: renderIfActive(<EmployeePage />),
  },
  pendingAbsenceRequests: {
    route: route('absences', 'pending-requests'),
    rolesWithAccess: [
      ManagerRole.DirectManager,
      ManagerRole.HrManager,
      ManagerRole.AbsenceApprover,
    ],
    render: renderIfActive(<AbsenceRequestsTabs />),
  },
  allAbsenceRequests: {
    route: route('absences', 'all-requests'),
    render: renderIfActive(<AbsenceRequestsTabs />),
  },
  reviews: {
    route: route('manager', 'reviews'),
    rolesWithAccess: [
      ManagerRole.DirectManager,
      ManagerRole.HrManager,
      ManagerRole.FeedbackManager,
    ],
    render: renderIfActive(<ManagerDashboard />),
  },
  goals: {
    route: route('manager', 'goals'),
    rolesWithAccess: [
      ManagerRole.DirectManager,
      ManagerRole.HrManager,
      ManagerRole.FeedbackManager,
    ],
    render: renderIfActive(<ManagerDashboard />),
  },
  skills: {
    route: route('manager', 'skills'),
    rolesWithAccess: [
      ManagerRole.DirectManager,
      ManagerRole.HrManager,
      ManagerRole.FeedbackManager,
    ],
    render: renderIfActive(<ManagerDashboard />),
  },
  learning: {
    route: route('manager', 'learning'),
    rolesWithAccess: [
      ManagerRole.DirectManager,
      ManagerRole.HrManager,
      ManagerRole.FeedbackManager,
    ],
    render: renderIfActive(<ManagerDashboard />),
  },
  myTeamOverview: {
    route: route('my-team/overview'),
    rolesWithAccess: [
      ManagerRole.DirectManager,
      ManagerRole.FeedbackManager,
      ManagerRole.AbsenceApprover,
      ManagerRole.TimeEntryApprover,
      ManagerRole.Compensation,
      ManagerRole.SeeEmployeeData,
      ManagerRole.HrManager,
    ],
    render: renderIfActive(<MyTeamTabs />),
  },
  myTeamChangeRequests: {
    route: route('my-team/change-requests'),
    render: renderIfActive(<MyTeamTabs />),
  },
  documents: {
    route: route('manager', 'employees', param('employeeId'), 'documents'),
    rolesWithAccess: managerRolesWhoHasAccessToDocuments,
    render: renderIfActive(<EmployeeDocuments />),
  },
  employeeInventory: {
    rolesWithAccess: [
      ManagerRole.DirectManager,
      ManagerRole.HrManager,
      ManagerRole.SeeEmployeeData,
    ],
    route: route('manager', 'employees', param('employeeId'), 'inventory'),
    render: renderIfActive(<EmployeeInventory />),
  },
  employeeNotes: {
    rolesWithAccess: [ManagerRole.DirectManager, ManagerRole.HrManager],
    route: route('manager', 'employees', param('employeeId'), 'notes'),
    render: renderIfActive(<ManagerDashboard />),
  },
  expense: {
    rolesWithAccess: [
      ManagerRole.DirectManager,
      ManagerRole.HrManager,
      ManagerRole.ExpenseApprover,
    ],
    route: route('manager', 'expense', param('id')),
    render: renderIfActive(<Expenses />),
  },
  expenses: {
    rolesWithAccess: [
      ManagerRole.DirectManager,
      ManagerRole.HrManager,
      ManagerRole.ExpenseApprover,
    ],
    route: route('manager', 'expenses'),
    render: renderIfActive(<Expenses />),
  },
  managerTickets: {
    rolesWithAccess: [
      ManagerRole.DirectManager,
      ManagerRole.FeedbackManager,
      ManagerRole.AbsenceApprover,
      ManagerRole.TimeEntryApprover,
      ManagerRole.Compensation,
      ManagerRole.SeeEmployeeData,
      ManagerRole.HrManager,
      ManagerRole.HelpDeskManager,
    ],
    route: route('manager', 'support', 'tickets'),
    render: renderIfActive(<SupportPage isManager={true} />),
  },
  analytics: {
    rolesWithAccess: [ManagerRole.DirectManager, ManagerRole.HrManager],
    route: route('analytics', 'overview'),
    render: renderIfActive(<AnalyticsOverview />),
  },
  absenceRate: {
    rolesWithAccess: [ManagerRole.DirectManager, ManagerRole.HrManager],
    route: route('analytics', 'absence-rate'),
    render: renderIfActive(<AbsenceRatePage />),
  },
  employeeTurnoverRate: {
    rolesWithAccess: [ManagerRole.DirectManager, ManagerRole.HrManager],
    route: route('analytics', 'employee-turnover-rate'),
    render: renderIfActive(<EmployeeTurnoverRatePage />),
  },
  employeeOvertime: {
    rolesWithAccess: [ManagerRole.DirectManager, ManagerRole.HrManager],
    route: route('analytics', 'employee-overtime'),
    render: renderIfActive(<EmployeeOvertimePage />),
  },
};
